<template>
  <Page>
    <v-container id="retreats" class="pt-6 pb-3 py-md-12 pt-lg-3 container-md">
      <h1
        v-html="$options.filters?.markdown($jms('retreats.title'))"
        v-show-timeout="[0, 'slide-y']"
        class="text-h4 text-md-h3 mb-3 mb-md-6"
      ></h1>

      <v-row>
        <v-col cols="12" md="8" class="pr-3 pr-md-12" v-show-timeout="[100, 'slide-x-reverse']">
          <div v-html="$options.filters?.markdown($jms('retreats.body'))"></div>

          <h3 class="mb-3" v-text="$t('retreats.upcoming.title')"></h3>
          <v-alert
            v-if="upcomingRetreats.length === 0"
            border="left"
            icon="mdi-calendar"
          >
            <span v-text="$t('retreats.upcoming.none')"></span>
          </v-alert>
          <v-simple-table v-else class="mb-4">
            <template #default>
              <thead>
              <tr>
                <th class="text-left" v-text="$t('table.headers.date')"></th>
                <th class="text-left" v-text="$t('table.headers.status')"></th>
                <th class="text-left" v-text="$t('table.headers.desc')"></th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="item in upcomingRetreats"
                :key="item.hash"
              >
                <td>{{ item.date }}</td>
                <td>
                  <v-chip v-if="item.status === 'active'" color="success" label small>{{ $t('status.' + item.status) }}</v-chip>
                  <v-chip v-else-if="item.status === 'full'" color="secondary" label small>{{ $t('status.' + item.status) }}</v-chip>
                  <v-chip v-else-if="item.status === 'cancelled'" color="error" label small>{{ $t('status.' + item.status) }}</v-chip>
                </td>
                <td>
                  <v-btn
                    :to="{ name: 'contact' }"
                    color="primary"
                    small
                    block
                  >
                    {{ $t('retreats.join') }}
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <h3 v-text="$t('retreats.cta.title')"></h3>
          <p v-text="$t('retreats.cta.body')"></p>
          <v-btn
            :to="{ name: 'contact' }"
            color="primary"
            block
            large
            class="mt-4"
          >
            {{ $jms('retreats.cta') }}
          </v-btn>
        </v-col>
        <v-col v-if="$jms('retreats.video.path')" cols="12" md="4" v-show-timeout="[100, 'slide-x']" class="mt-n6 mt-md-0">
          <v-divider v-if="$vuetify.breakpoint.smAndDown" class="my-6"></v-divider>

          <Sticky v-model="$vuetify.breakpoint.mdAndUp">
            <v-card
              :tile="$vuetify.breakpoint.smAndDown"
              color="background"
              class="pa-4 text-center"
            >
              <h3 class="mb-1">Watch Preview</h3>
              <VideoPlayer
                :aspect-ratio="9/16"
                :src="$jmsPath($jms('retreats.video'))"
                controls
              />
            </v-card>
          </Sticky>
        </v-col>
      </v-row>
    </v-container>

    <v-sheet v-if="medias.length > 0" color="background" class="py-md-8">
      <v-container class="container-md">
        <h3 class="mb-3" v-text="$t('retreats.gallery')"></h3>
        <v-row v-masonry="'retreat_gallery'">
          <v-col
            v-for="(media, mediaIdx) in medias"
            :key="media.hash"
            cols="12"
            md="4"
            class="py-2"
          >
            <v-card v-show-timeout="[(50 * mediaIdx) + 300, 'slide-y']">
              <v-img :src="media.url" :aspect-ratio="media.width / media.height">
                <template #placeholder>
                  <v-overlay absolute>
                    <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>
                  </v-overlay>
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </Page>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import Page from '@/components/Page.vue'
import Sticky from '@/components/Sticky.vue'
import VideoPlayer from '@/components/VideoPlayer.vue';

@Component({
  components: {
    VideoPlayer,
    Page,
    Sticky,
  }
})
export default class RetreatsView extends Vue {

  // @ts-ignore
  @Watch('medias')
  onMediasChange() {
    this.$nextTick(this.redrawMasonry);
  }

  images: Array<string> = [
    '/images/jungle-house.jpg',
    '/images/dolama-shaman.jpg',
    '/images/san-pedro.jpg',
  ]

  get upcomingRetreats(): { hash: string, date: any, status: 'active' | 'cancelled' | 'full' }[] {
    return (this.$jms('retreats.upcoming') || []).filter((item: any) => {
      return item.date && item.status && new Date(item.date) > new Date();
    });
  }

  get medias(): { hash: string, url: string, width: number, height: number }[] {
    return (this.$jms('retreats.gallery') || []).map((item: any) => {
      return {
        hash: item.hash,
        url: this.$jmsPath(item),
        width: item.meta.width,
        height: item.meta.height,
      }
    })
  }

  redrawMasonry(): void {
    // @ts-ignore
    this.$redrawVueMasonry('retreat_gallery');
  }
}
</script>
